import { Card, Notice } from '../ui';
import { CrudScreen } from './CrudScreen';
import { AGENDADAS, CAMPANHAS, CONTATOS, MODELOS, TAGS } from './recursos';
import { Metricas, Overview } from './Panorama';
import { Arquivos, Integracoes, Numeros } from './Configuracao';
import { TestarMensagem } from './TestarMensagem';
import { Inbox } from './Inbox';
import { RespostasAutomaticas } from './Automacao';
import { AgentesIA } from './AgentesIA';
import { Configuracoes } from './Configuracoes';
import { Operadores } from './Operadores';
import { IntegrationMonitor } from './IntegrationMonitor';
import type { ViewId } from '../nav/nav-items';

/**
 * Mapa de tela por rota.
 *
 * O que ainda não migrou aparece com aviso explícito, e não como tela vazia:
 * uma seção que abre em branco é indistinguível de uma que quebrou.
 */
export function Screen({ view, onNavigate, conversationId }: { view: ViewId; onNavigate: (view: ViewId) => void; conversationId?: string | null }) {
  switch (view) {
    case 'inbox': return <Inbox initialConversationId={conversationId} />;
    case 'overview': return <Overview />;
    case 'metrics': return <Metricas />;
    /* Todas estas rotas usam o mesmo componente genérico. A chave precisa
       acompanhar a rota para o React não reaproveitar estado e dados da tela
       anterior durante a navegação (por exemplo, Etiquetas -> Contatos). */
    case 'tags': return <CrudScreen key="tags" config={TAGS} />;
    case 'contacts': return <CrudScreen key="contacts" config={CONTATOS} />;
    case 'templates': return <CrudScreen key="templates" config={MODELOS} />;
    case 'campaigns': return <CrudScreen key="campaigns" config={CAMPANHAS} />;
    case 'scheduled': return <CrudScreen key="scheduled" config={AGENDADAS} />;
    case 'agents': return <Operadores />;
    case 'channels': return <Numeros />;
    case 'files': return <Arquivos />;
    case 'integrations': return <Integracoes onOpenAgents={() => onNavigate('ai-agents')} />;
    case 'integration-monitor': return <IntegrationMonitor />;
    case 'message-test': return <TestarMensagem />;
    case 'autoreplies': return <RespostasAutomaticas />;
    case 'ai-agents': return <AgentesIA />;
    case 'settings': return <Configuracoes />;
    default:
      return (
        <Card>
          <Notice tone="info" title="Ainda no front anterior">
            <p>Esta seção ainda não foi migrada.</p>
          </Notice>
        </Card>
      );
  }
}
